var map = {
	"./el_img_face_default.png": "gsDU",
	"./el_live_lesson_audio_left.png": "4dW4",
	"./el_live_lesson_audio_right.png": "VkxO",
	"./el_msg_attach_upload.png": "rDrE",
	"./el_msg_file_excel.png": "oCOv",
	"./el_msg_file_image.png": "GdQG",
	"./el_msg_file_pdf.png": "MD/A",
	"./el_msg_file_ppt.png": "gtF9",
	"./el_msg_file_txt.png": "uA3g",
	"./el_msg_file_unknown.png": "PvE/",
	"./el_msg_file_video.png": "132u",
	"./el_msg_file_word.png": "Mn1n",
	"./el_msg_file_zip.png": "gli7",
	"./el_msg_icon_delete.png": "k4Ot",
	"./el_msg_icon_left_ai_answer.png": "OTzj",
	"./el_msg_icon_left_ai_ask.png": "K7HE",
	"./el_msg_icon_left_answer.png": "9Nx5",
	"./el_msg_icon_left_ask.png": "UGuk",
	"./el_msg_icon_white_ai_answer.png": "Oajt",
	"./el_msg_icon_white_ai_ask.png": "lqLo",
	"./el_msg_icon_white_answer.png": "GZon",
	"./el_msg_icon_white_ask.png": "suHE",
	"./el_msg_unread_close.png": "5Fro",
	"./el_msg_unread_jump.png": "9HUw",
	"./el_msg_voice_setting.png": "jIPQ",
	"./ic_courseware_ask_bg.png": "oHAY",
	"./ic_courseware_msg_qa_in.png": "Eqs3",
	"./ic_lesson_live_teacher_online.png": "Lfep",
	"./ic_lesson_live_unstart.png": "Yw6x",
	"./ic_loading.gif": "9F4+",
	"./ic_msg_panel_close.png": "MzCX",
	"./ic_msg_qa_answer_arrow.png": "TpAe",
	"./ic_msg_qa_answer_close.png": "SQCi",
	"./ic_msg_qa_answer_title.png": "gmvU",
	"./ic_msg_qa_in.png": "4jRK",
	"./ic_play.png": "0sRs",
	"./ic_recording_play.png": "aJgY",
	"./padcontrol_home.png": "H6I6",
	"./padcontrol_home_bg.png": "tyI7",
	"./padcontrol_home_preview1.png": "zh/n",
	"./padcontrol_home_preview2.png": "b/Ax",
	"./padcontrol_logo_title.png": "SHgq",
	"./setup001.jpg": "XVOt",
	"./setup002.jpg": "60fo",
	"./setup003.jpg": "EqSF",
	"./setup004.jpg": "eEMc",
	"./setup005.jpg": "pjE8",
	"./setup006.jpg": "QE0U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82